import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const STATUS_SWITCH_CLASS_NAME = 'StatusSwitch';
export const STATUS_SWITCH_CLASS_SLOTS = ['root', 'thumb'] as const;

export type StatusSwitchClassSlot = (typeof STATUS_SWITCH_CLASS_SLOTS)[number];

export interface StatusSwitchClasses {
	root: string;
	error: string;
	thumb: string;
}

export type StatusSwitchClassKey = keyof StatusSwitchClasses;

export const getStatusSwitchUtilityClass = (slot: string) =>
	generateUtilityClass(STATUS_SWITCH_CLASS_NAME, slot);

export const statusSwitchClasses = generateUtilityClasses<
	keyof StatusSwitchClasses
>(STATUS_SWITCH_CLASS_NAME, ['root', 'error', 'thumb']);

export default statusSwitchClasses;
